import { Syringe } from "@faizaanceg/syringe";

const oboxToWebproMap = {
  "Internal Server Error":
    "There was some error while performing the action. Please try again in a few minutes",
  "There is already an action pending on this Order.":
    "There is already an action pending on this Order. Please try again in a few minutes",
  "{newipaddr=Invalid IP Address Format}": "Invalid IP address",
  "A Child Name Servers can only be registered under your Domain Name. For instance, a Child Name Server ns2.xyz.com maybe registered only under xyz.com":
    "Child Name Servers can only be registered under your Domain Name. For instance, a Child Name Server ns2.xyz.com maybe registered only under xyz.com",
  "Unable to send Mail : finished trying all SMTP hosts.":
    "Unable to send mail. Please try again in sometime."
};

const OboxErrorMessages = [
  "error",
  "failed",
  "There is already an action pending on this Order.",
  "failure"
];

function formatStatusText(response: Response) {
  return response.statusText?.length > 0
    ? response.statusText
    : `${response.status} Network Error`;
}

const helpers = {
  checkForError: async (request: Request, response: Response) => {
    let error = new Error(formatStatusText(response));
    // @ts-expect-error We're setting the status property on the error object
    error.status = response.status;
    // @ts-expect-error We're setting the response property on the error object
    error.response = response;
    const runtime = Syringe.inject("runtime");
    if (runtime.environment !== "production") {
      console.error("API Call Failed: ", error.message, request, response);
    }
    if (response.headers.get("Content-Type")?.includes("application/json")) {
      let apiResponse = await response.json().catch(() => ({
        message: "Some error has occurred. Please try again later"
      }));
      error.message = apiResponse.message ?? apiResponse.error ?? error.message;
      // @ts-expect-error We're setting the response property on the error object
      error.response = new Response(JSON.stringify(apiResponse));
    }
    throw error;
  },
  parseResponse: async (
    response: Response
  ): Promise<Record<string, unknown>> => {
    let rawResponse = await response.text();
    if (response.status === 204 || rawResponse === "") {
      return {};
    }
    try {
      return JSON.parse(rawResponse);
    } catch {
      throw rawResponse;
    }
  },
  checkIfOboxError: response => {
    const {
      status = "",
      msg = "",
      code,
      actionstatusdesc = msg,
      message = actionstatusdesc,
      reason = message,
      error = reason,
      response: errorBody = {
        status,
        message: error
      }
    } = response;

    if (
      (((typeof errorBody.status === "string" &&
        OboxErrorMessages.includes(errorBody.status.toLowerCase())) ||
        OboxErrorMessages.includes(errorBody.message) ||
        status > 400 ||
        (response.error && response.error !== "NoError")) &&
        errorBody?.status?.toLowerCase() !== "success") ||
      !!code
    ) {
      let apiFailure = new Error(
        oboxToWebproMap[errorBody.message] ?? errorBody.message
      );
      // @ts-expect-error We're setting the response property on the error object
      apiFailure.response = new Response(JSON.stringify(response));
      throw apiFailure;
    }
  }
};

export const OBVisitor = {
  async ok<T>(response: Response) {
    let data: T | Record<string, unknown>;
    try {
      data = await helpers.parseResponse(response);
    } catch (rawResponse) {
      return rawResponse as T;
    }
    helpers.checkIfOboxError(data);
    return data as T;
  },
  fail: helpers.checkForError
};
